import { CSSProperties } from 'react';

type UnitTableContainerStyleOptions = {
  isSmall: boolean;
  safeTopPadding: number;
  showSearch: boolean;
  showFilter: boolean;
  screenBreakLevel: number;
  buildingCount: number;
  floorCount: number;
};

export const buildUnitTableContainerStyle = ({
  isSmall,
  safeTopPadding,
  showSearch,
  showFilter,
  screenBreakLevel,
  buildingCount,
  floorCount,
}: UnitTableContainerStyleOptions): CSSProperties => {
  if (isSmall) {
    return {
      height: '100%',
      maxHeight: '100%',
    };
  }

  const occupiedHeight =
    242 +
    (showSearch ? 60 : 0) +
    (showFilter ? (screenBreakLevel > 2 ? 46 : 72) : 0) +
    (showFilter && buildingCount > 1 ? (screenBreakLevel > 2 ? 56 : 0) : 0) +
    (showFilter && floorCount > 1 ? (screenBreakLevel > 2 ? 56 : 0) : 0);

  return {
    height: 'auto',
    maxHeight: `calc(100vh - ${occupiedHeight + safeTopPadding}px)`,
  };
};
